<app-checkbox
    *ngFor="let item of showOptions"
    [fc]="innerForm.controls[item.key]"
    [label]="item.title">
</app-checkbox>